import { NumberedBadge } from '@piccolohealth/ui';
import React from 'react';
import { useParticipantUsersMinimalQuery } from '../../graphql/hooks/useParticipantQuery';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantId: string;
}

export const ParticipantTeamBadge = (props: Props) => {
  const { participantId } = props;
  const { organization } = useAppContext();

  const usersQuery = useParticipantUsersMinimalQuery({
    organizationId: organization.id,
    participantId,
  });

  const users = usersQuery.data?.organization?.participant?.assignedUsers ?? [];

  return <NumberedBadge count={users.length} />;
};
